import { cn } from 'utils/helpers'
import styles from './input-group.module.scss'

export default function InputGroup({ children, className, forceMobile }) {
    return <div className={cn(styles.group, forceMobile && styles.forceMobile, className)}>{children}</div>
}
